const ElementoAer = (props) => {

    const formato = 'text-center'

   
    return (<>
        <div className="w-full flex bg-zinc-200 flex-row justify-between"  onClick={e => props.setUpdData(props.obj)} key={props.obj.id}>
            <input 
                type="checkbox" 
                id={props.obj.id}  
                checked={props.obj.s}
                onChange={(e => props.elegir(props.obj.id))}
            />
             <div className="px-5 grid grid-cols-11 w-full">
              <label className=''>{props.obj.apellido===props.obj.apellido.substring(0,30) ? props.obj.apellido : props.obj.apellido.substring(0,30) + '...'}</label>
              <label className=''>{props.obj.nombreo===props.obj.nombre.substring(0,30) ? props.obj.nombre : props.obj.nombre.substring(0,30) + '...'}</label>
              <label className='col-span-2'>{props.obj.email.substring(0,30)===props.obj.email ? props.obj.email : props.obj.email.substring(0,30) + '...'}</label>
              <label>{props.obj.documento}</label>
              <label>{props.obj.rubro.substring(0,20)}</label>
              <label className='col-span-2'>{props.obj.empresa}</label>
              <label>{props.obj.cargo}</label>
              <label>{!props.obj.codigo ? 'Público' : 'Invitado'}</label>
              <label className={formato}>{props.evento.prefijoqr + props.obj.id.toString().padStart(parseInt(props.evento.cifrasqr),'0')}</label>
            </div>
        </div>
        </>)
}

export default ElementoAer